// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "319378de304bee6e" + ".js";
};